module.exports = __webpack_public_path__ + "static/media/profile-picture-256w.9c306e19.jpg";